import googlePreferredIcon from "@assets/icons/googlePreferredSource.png";
import { GOOGLE_PREFERRED_SOURCES_LINK } from "@config/constants";
import LinkIcon from "@elements/LinkIcon/LinkIcon";
import { BH_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";

export type GooglePreferredSourceButtonProps = {
  className?: string;
  pageUrl: string;
};
/**
 * A React component that renders a Google Preferred Source Button on Article page
 */
export default function GooglePreferredSourceButton({
  className,
  pageUrl,
}: GooglePreferredSourceButtonProps): React.ReactElement {
  const BhCustomGaEvent = useBHCustomEventAnalyticsCall();

  const handleOnClick = () => {
    BhCustomGaEvent(
      "preferred source on google",
      "click",
      `${removeTrailingSlash(BH_BASE_URL)}${pageUrl}`,
    );
  };

  return (
    <div className={className}>
      <LinkIcon
        destination={GOOGLE_PREFERRED_SOURCES_LINK}
        onClick={handleOnClick}
        src={googlePreferredIcon}
        alt="Google News Preferred Icon"
        height="39px"
        width="125px"
      />
    </div>
  );
}
